function readCount(input){
    if (input.type === 'checkbox') {
        return input.checked ? 1 : 0;
    }
    return parseInt(input.value || 0);
}

export function readRowQuantities(cardRow){
    return {
        "owned_count": readCount(cardRow.querySelector('.collect-input')),
        "trade_count": readCount(cardRow.querySelector('.trade-input')),
        "wanted_count": readCount(cardRow.querySelector('.wanted-input'))
    };
}

function saveCard(cardRow){
    return fetch(`/user/card/${cardRow.id}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(readRowQuantities(cardRow))
    })
        .then(response => response.json());
}

export function handleCollectionUpdateRequest(event, saveTimers){
    const cardRow = event.target.closest('.card-row');
    if (!cardRow) { return; }

    const cardId = cardRow.id;
    const pending = saveTimers.get(cardId);

    if (pending) {
        clearTimeout(pending.timer);
    }
    const run = () => {
        saveTimers.delete(cardId);
        return saveCard(cardRow);
    };
    saveTimers.set(cardId, { timer: setTimeout(run, 750), run });
}

// Sends any saves still waiting out their debounce, so a bulk update starts from what the user last entered
export function flushPendingSaves(saveTimers){
    const runs = [...saveTimers.values()].map(pending => {
        clearTimeout(pending.timer);
        return pending.run();
    });
    return Promise.allSettled(runs);
}
